import { ChipDisplay } from 'common/components/Chips/ChipDisplay';
import { useAssignedTags } from './hooks/useAssignedTags';
import { useMemo } from 'react';

export type TagDisplayProps = {
  initialTags: string[];
  id: string;
  hasMore: boolean;
  shouldWrap?: boolean;
  preventRefetch?: boolean;
};

export const TagDisplay: React.FC<TagDisplayProps> = ({
  initialTags,
  id,
  hasMore,
  shouldWrap,
  preventRefetch = false,
}) => {
  const { data, refetch } = useAssignedTags(id, false);

  const labels = useMemo(() => data?.map(({ name }) => name), [data]);
  return (
    <ChipDisplay
      previewLabels={initialTags}
      loadedLabels={labels}
      onLoad={() => {
        if (!preventRefetch) {
          refetch();
        }
      }}
      hasMore={hasMore}
      shouldWrap={shouldWrap}
    />
  );
};
